import React, {Component} from 'react';

import { initAmplitude, logSocialLinkClickEvent, logSocialShareViewEvent } from '../../../shared/redux/amplitude';

import { Campaign, CampaignPreviewCard}  from 'dabbl-react-components';
import { parseQueryString } from '../../../shared/utils';
import {trackSocialShare} from "../../../shared/redux/entities/actions";

class PreviewCampaign extends Component {
  constructor(props) {
    super(props);
    const query = parseQueryString(this.props.location.search);
    this.state = {isPreviewShown: false, isLoading: true, downloadLinkOnConclusion: query.downloadLink }
  }

  componentDidMount() {
    if (this.state.downloadLinkOnConclusion) {
      initAmplitude()
    }
    Promise.resolve()
      .then(() => this.props.getPreviewCampaign(this.props.previewToken))
      .then(campaign => {
          this.setState({isLoading: false, campaign: campaign})
          if (campaign) {
            this.trackPreviewView(campaign)
          }
        }
      )
      .catch(() => this.setState({isLoading: false}))
    window.onpopstate = (e) => {
      if (!this.state.isPreviewShown){ return }
      this.setState({isPreviewShown: false})
    }
  }

  handlePreviewClick() {
    window.history.pushState({}, null, '#content');
    this.setState({isPreviewShown: true})
  }

  backToPreview() {
    window.history.back();
  }

  onRateClick() {
    if (this.state.downloadLinkOnConclusion) {
      return
    }
    this.backToPreview()
  }

  onSkipClick() {
    if (this.state.downloadLinkOnConclusion) {
      return
    }
    this.backToPreview()
  }

  trackPreviewView(campaign){
    logSocialLinkClickEvent(campaign.name)
    this.props.trackSocialShare(campaign.id, 'start')
  }

  trackConclusionView(campaign){
    logSocialShareViewEvent(campaign.name)
    this.props.trackSocialShare(campaign.id, 'end')
  }

  render() {
    const {isPreviewShown, isLoading, campaign} = this.state;
    if (isLoading) {
      return <div> Loading... </div>
    }
    if (!campaign) {
      return <div>Can't load campaign...</div>
    }

    return (
      <div className='vertical-center' style={{height: "100%"}}>
        {isPreviewShown ? (
          <div className="PreviewCampaign">
            <Campaign
              campaign={campaign}
              hideTotalValue
              showToast={ !this.state.downloadLinkOnConclusion }
              usePoints={true}
              hideToastCopy={true}
              downloadLinkOnConclusion={this.state.downloadLinkOnConclusion}
              onCloseCampaign={() => this.backToPreview()}
              onRateCampaign={() => this.onRateClick()}
              onSkipRateCampaign={()=>this.onSkipClick()}
              onAllEngagementsAnswered={()=> this.state.downloadLinkOnConclusion && this.trackConclusionView(campaign)}
            />
          </div>
          ) : (
           <div className="PreviewCampaign_PreviewCard">
             <CampaignPreviewCard
              brandName={campaign.brandName}
              totalValue={campaign.totalValue}
              imgSrc={campaign.feedimageurl}
              isNewDesign={true}
              usePoints={true}
              text={campaign.feedtext}
              textSecondary={ this.state.downloadLinkOnConclusion === undefined ? `earn with ${campaign.brand.name}` : `provided by ${campaign.brand.name}`}
              onClick={() => this.handlePreviewClick()}
            />
           </div>
          )
        }
      </div>
    );
  }
}

export default PreviewCampaign;



// WEBPACK FOOTER //
// ./src/routes/PreviewCampaign/components/PreviewCampaign.js